import React from 'react'
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import locale from 'date-fns/locale/ja'

export default function ThemeProvider(props: { children: React.ReactNode }) {
  const mode = 'dark'

  const theme = createTheme({
    palette: {
      mode,
      primary: { main: '#ff6600' },
      secondary: { main: '#556677' },
      background:
        mode === 'dark'
          ? {
              default: '#2a2a2a'
            }
          : {
              default: '#eeeeee'
            }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
        #root {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
      `
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            borderRadius: 3,
            boxShadow:
              '0px 1px 1px rgba(0, 0, 0, .1), inset 0px -18px 6px rgba(0, 0, 0, .05), inset 0px 0px 0px 1px rgba(0, 0, 0, .1)',
            color: 'white'
          }
        },
        variants: [
          {
            props: { size: 'medium' },
            style: { height: 32 }
          },
          {
            props: { size: 'small' },
            style: { height: 28 }
          }
        ]
      }
    }
  })

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        {props.children}
      </LocalizationProvider>
    </MuiThemeProvider>
  )
}
